/**
 * Setear companies.
 */
export function setListCompany(state, companies) {
    state.companies = companies
}

/**
 * Setear productos de compañia
 */
export function setProductsCompany(state, products) {
    state.products = products
}

/**
 * Setear una orden.
 */
export function setOrdersByEmploy(state, orders) {
    state.orders = orders
}

/**
 * Actualizar una orden
 */
export function updateOrder(state, productUpdated) {
    const index = state.products.data.findIndex(item => item.id == productUpdated.id);
    state.products.data.splice(index, 1, productUpdated)
}

/**
 * Cambiar de pagina en paginacion
 */
export function changePerPage(state, per_page) {
    state.filter.per_page = per_page;
}


/**
 * Setear el permiso et
 */
export function setPermissionsEt(state, permissionsEt) {
    state.permissionsEt = permissionsEt;
}


/**
 * Setear el permiso et
 */
export function setNameModule(state, name_module) {
    state.name_module = name_module;
}

/**
 * Resetear paginacion
 */
export function resetPage(state) {
    state.filter.page = 1;
}

/**
 * Limpiar filtro
 */
export function clearFilter(state, company_id) {
    state.filter = {
        company_id,
        order: null,
        state: null,
        from: null,
        to: null,
        page: 1,
        per_page: 10,
        sortBy: 'id',
        sort: 'DESC',
    }
}

/**
 * Carga de datos select.
 */
export function setLoadingDataSelect(state, loading_data_select) {
    state.loading_data_select = loading_data_select;
}

/**
 * Establecer filtro empresa.
 */
export function setCompaniesFilter(state, companies) {
    localStorage.setItem('companies', JSON.stringify(companies))
    state.companies = companies;
}

/**
 * Setear companies
 */
export function setEmpresasLocal(state, companies) {
    state.companies = companies;
}

/**
 * Establecer filtro fabricantes.
 */
export function setManufacturerFilter(state, manufacturers) {
    state.manufacturers_filter = manufacturers;
}

/**
 * Setear producto.
 */
export function setProduct(state, etProduct) {
    state.etProduct = etProduct;
}

/**
 * Actualizar producto.
 */
export function updateProduct(state, productUpdated) {
    const index = state.products.data.findIndex(item => item.id == productUpdated.id);
    state.products.data.splice(index, 1, productUpdated);
}



